export default __webpack_public_path__ + "static/media/pin.0e5845b4.svg";